<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<guahaoList></guahaoList>
		</div>
		<div class="add" v-if="type==='add'">
			<guahaoAdd></guahaoAdd>
			<div class="settlementBox">
				<guahaoSettlement></guahaoSettlement>
			</div>
		</div>
	</div>
</template>
<script>
	import guahaoAdd from "./comp/guahao_add.vue"
	import guahaoList from "./comp/guahao_list.vue"
	import guahaoSettlement from "./comp/guahao_settlement.vue"
	export default {
		components:{guahaoAdd,guahaoList,guahaoSettlement},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.guahao.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	position: relative;
	width:100%;
	height: 100%;
	.settlementBox{
		position: absolute;
		bottom:0;
		width:100%;
	}
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
